{
  "name": "@mottosports/motto-video-player",
  "version": "1.1.0",
  "description": "React video player component for the Motto platform, powered by Shaka Player",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "files": [
    "dist",
    "README.md"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "NODE_ENV=development tsup --watch",
    "dev:hot": "NODE_ENV=development tsup --watch --onSuccess \"echo 'Hot reload ready! Package rebuilt successfully.'\"",
    "clean": "rm -rf dist",
    "test": "echo \"Error: no test specified\" && exit 1",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "video",
    "player",
    "react",
    "component",
    "motto",
    "shaka",
    "adaptive-streaming",
    "dash",
    "hls",
    "drm"
  ],
  "author": "Motto UI Components",
  "license": "ISC",
  "dependencies": {
    "@buf/motto_cda.bufbuild_es": "^2.11.0-20260702135849-6e5b189e7924.1",
    "@bufbuild/protobuf": "^2.11.0",
    "@connectrpc/connect": "^2.1.2",
    "@connectrpc/connect-web": "^2.1.2",
    "@mux/mux-data-shakaplayer": "^5.14.7",
    "@tanstack/react-query": "^5.80.3",
    "shaka-player": "^4.16.0",
    "tailwind-merge": "^3.3.0",
    "zustand": "^5.0.2"
  },
  "devDependencies": {
    "@types/node": "^22.15.29",
    "@types/react": "^18.2.79",
    "@types/react-dom": "^19.1.5",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "peerDependencies": {
    "react": ">=16.8.0",
    "react-dom": ">=16.8.0",
    "tailwindcss": ">=3.0.0"
  },
  "publishConfig": {
    "access": "public"
  }
}
